<div class="row h-100 w-100" style="background-color: #F9F9F9;">
  <div class="col-12" style="display: flex;
      justify-content: center;">

    <!-- <div style="z-index : 10;position: absolute;" class="col-12">
      <img src={{fortgotBgCover[0].forgotPasswordBgImg}} alt="login" class="login" height="635" style="width: inherit;filter: blur(16px);
      -webkit-filter: blur(16px);" width="1340">
    </div> -->

    <div class="d-flex form loginContainer" style="z-index : 100;">
      <div *ngIf="check" class="col-12"
        style="height:100%;width:100%; display: flex; justify-content: center; align-items:center;">
        <div class="d-flex justify-content-center" style="z-index: 100;width:100%" *ngIf="!verify">
          <div class="card cardBox">
            <div class="card-body">
              <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" novalidate>
                <div>

                  <h2 class="text-center">Forgot Password</h2>
                  <p class="text-center">You can reset your password here.</p>


                  <!-- <div style="position:relative;margin-top: -19px;">
                <span style="padding-left: 13px;">
                  <i style="color: #BFBFBF;font-size:20px;position: absolute;
              top: 56px;" [ngClass]="fortgotBgCover[0].placeholderIcon"></i>
                  <input type="email" style="padding-left: 46px;" formControlName="facility_name" class="form-control mt-4"
                    placeholder="Please enter facility name" name="email" />
                </span>
              </div>
              <span class="text-danger mt-2 mb-2"
                *ngIf="!forgotForm.get('email').valid && forgotForm.get('email').touched">
                Please enter a valid facility name!
              </span> -->


                  <div style="position:relative;margin-top: -19px;">
                    <span style="padding-left: 13px;">
                      <!-- <i style="color: #BFBFBF;font-size:20px;posi tion: absolute; -->
                      <!-- top: 56px;" [ngClass]="fortgotBgCover[0].placeholderIcon"></i> -->
                      <i class="fa fa-key" style="color: #BFBFBF;font-size:20px;position: absolute;top: 56px;"
                        aria-hidden="true"></i>
                      <input type="email" style="padding-left: 46px;" formControlName="email" class="form-control mt-4"
                        placeholder="Enter your email" name="email" />
                    </span>
                  </div>
                  <span class="text-danger mt-2 mb-2"
                    *ngIf="!forgotForm.get('email').valid && forgotForm.get('email').touched">
                    Please enter a valid email id!
                  </span>
                  <!-- <div *ngFor="let validation of controls.validations">
                    <span *ngIf="forgotForm.controls[controls.label].touched && forgotForm.controls[controls.label].errors">
                      <p *ngIf="forgotForm.controls[controls.label].errors[validation.name]" class="text-danger">
                        {{validation.message}}
                      </p>
                    </span>
                  </div> -->
                  <!-- <div *ngIf="forgotForm.email.errors" class="invalid-feedback">
                    <div *ngIf="forgotForm.email.errors.required">Email is required</div>
                    <div *ngIf="forgotForm.email.errors.email">Email must be a valid email address</div>
                </div> -->
                  <br>
                </div>
                <div class="text-center mt-2">
                  <input type="submit" class="btn btn-primary" style="background-color: #ED1556;color:white;"
                    [disabled]="!forgotForm.valid" />
                  <button type="button" class="btn btn-success ms-3"
                    style="border: 1px solid #ED1556;color:#ED1556;background-color: white;"
                    onclick="javascript:window.history.back();">Go Back</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div  *ngIf="check" style="z-index: 100;position: fixed;" class="col-12">
        <!-- <ngx-loader [show]="show"  [fullScreen] = "fullScreen" [template]="template"> Loading... </ngx-loader> -->
        <div class="text-center">

          <div class="verify d-flex" *ngIf="verify">
            <div class="card" style="width: 30rem;height: fit-content;">
              <div class="card-body">
                <div class="d-flex" style="justify-content: center;">
                  <h3><i class="fa fa-lock fa-2x"></i></h3>
                  <h5 class="card-title ms-3 mt-3">Validate OTP</h5>

                </div>
                <p>Otp has been sent to your email.</p>
                <!-- <p class="card-subtitle mb-2 text-muted">OTP</p> -->
                <input placeholder="Enter your 6 digit OTP." id="otp" type="text" [formControl]="otp"
                  class="form-control" #term (keyup)="checkVal(term.value)" maxlength="6">
                <button type="button" (click)="validate()" style="background-color: #ED1556;color:white;"
                  class="btn btn-primary mt-3" [disabled]="!validateCheck">Validate</button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="passwordVariable" class="col-12"
        style="z-index: 100;position: fixed;display: flex; justify-content: center; margin-top: 140px;"
        class="col-12">
        <div class="card" style="width: 30rem;height: fit-content;">
          <form [formGroup]="passwordForm" (ngSubmit)="savePassowrd()">
            <div class="card-body">
              <h5 class="card-title">Enter your new password</h5>
              <label for="password">New password </label>

              <div style="position:relative;margin-top: -19px;">
                <span style="padding-left: 13px;">
                  <i style="color:#BFBFBF;font-size:20px;position: absolute;
              top: 44px;" class="fa fa-lg fa-lock"></i>
                  <input id="password" [type]="shows ? 'text' : 'password'" style="padding-left: 46px;"
                    placeholder="Enter Password" formControlName="password" class="form-control mt-2"><span
                    class="showIcon">
                    <i class="fa fa-eye" *ngIf="shows" (click)="password()" style="color:#ED1556"></i>
                    <i class="fa fa-eye-slash" *ngIf="!shows" (click)="password()" style="color:#ED1556"></i>
                  </span>
                </span>
              </div>

              <div *ngIf="passwordForm.controls.password.status != 'VALID' && passwordForm.value.password.length >= 1"
                class="passPatternErrMsg">
                <ul>
                  <li>Password must contain a minimum of eight characters</li>
                  <li>At least one letter</li>
                  <li>At least one number</li>
                  <li>At least one special character</li>
                </ul>
              </div>

              <label for="confirmPassword"
                [ngClass]="passwordForm.controls.password.status != 'VALID' && passwordForm.value.password.length >= 1 ? 'mt-1' : 'mt-4'">Confirm
                password </label>
              <div style="position:relative;margin-top: -19px;">
                <span style="padding-left: 13px;">
                  <i style="color:#BFBFBF;font-size:20px;position: absolute;
              top: 44px;" class="fa fa-lg fa-lock"></i>
                  <input id="confirmPassword" [type]="showBottom ? 'text' : 'password'" style="padding-left: 46px;"
                    placeholder="Re-Enter Password" formControlName="confirmPassword" class="form-control mt-2"><span
                    class="showIcon">
                    <i class="fa fa-eye" *ngIf="showBottom" (click)="passwordBottom()" style="color:#ED1556"></i>
                    <i class="fa fa-eye-slash" *ngIf="!showBottom" (click)="passwordBottom()" style="color:#ED1556"></i>
                  </span>
                </span>
              </div>
              <div *ngIf="passwordForm.hasError('passwordMismatch') && passwordForm.value.confirmPassword.length >= 1"
                class="passNotMatch">Password don't match. Try again.</div>
            </div>
            <div class="text-center mb-3">
              <input type="submit" class="btn btn-primary" style="background-color: #ED1556;color:white;"
                [disabled]="!passwordForm.valid" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>